import axios from 'axios';
import { IPatient } from 'app/models/patient.models';

const basePath = '/patients';

export const patientService = {
  getPatientByEventId: (eventId: number): Promise<IPatient> => axios.get(`${basePath}/by-event/${eventId}`),
};
